import { createFileRoute } from "@tanstack/react-router";
import AccessBuildingSettings from "@/components/building_admin/building_admin_settings/access";
import { buildingOptions } from "@/api";
import { SettingsSubPage } from "@/components/building_admin/building_admin_settings/SettingsSubPage";
import { useWelcomeAccessAccess } from "@/hooks/useWelcomeAccessAccess";
import { useRouterStore } from "@/store/zustandStore";

const PageComponent = () => {
  const { buildingIntegratedWithAccessControlSystem } =
    useWelcomeAccessAccess(true);
  const card = {
    icon: "badge",
    value: "access",
    label: "Welcome Access",
    enabled: buildingIntegratedWithAccessControlSystem,
    to: "/building/settings/access",
    descriptionKey: "PAGES.BUILDING_SETTINGS.MODULE_DESCRIPTIONS.ACCESS",
  };
  return (
    <SettingsSubPage
      cardOptions={card}
      PageComponent={AccessBuildingSettings}
      label="Access"
      path="/building/settings/access"
    />
  );
};

export const Route = createFileRoute("/_portal/building/settings/access")({
  component: PageComponent,
  loader: () => {
    const { queryClient } = useRouterStore.getState();
    if (!queryClient) return;
    queryClient.ensureQueryData(buildingOptions);
  },
});
